module.exports = __webpack_public_path__ + "static/3-f87e834be6c3e539e835849e22638072.jpeg";